import { render, staticRenderFns } from "./MeasurementsPage.vue?vue&type=template&id=e1ba5556&"
import script from "./MeasurementsPage.vue?vue&type=script&lang=js&"
export * from "./MeasurementsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports